import React, { useState, useEffect ,useRef } from "react";
import L from "leaflet";
import { Line, Pie, Column ,Bar} from "@ant-design/charts";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  
} from "react-leaflet";
import { Checkbox,Button, Col, Row,notification } from "antd";
import Routing from "../MapRoutes/MapRoutes";

import "./Map_polilineas.scss";
import "leaflet/dist/leaflet.css";


export default function Map_economy(props) {
  function copiarTexto(locations,typeVeh) {

    const origin = locations[0];
    const destination = locations[locations.length - 1];
    const waypoints = locations.slice(1, -1);
    
    let url = `https://www.google.com/maps/dir/?api=1&destination=${destination[0]},${destination[1]}&origin=${origin[0]},${origin[1]}&waypoints=`;
    waypoints.forEach(waypoint => {
      url += `${waypoint[0]},${waypoint[1]}|`;
    });
    url = url.slice(0, -1);
    url += (typeVeh==='van')
              ?'&travelmode=driving&dir_action=navigate'
              :'&travelmode=bicycling&dir_action=navigate';
    navigator.clipboard.writeText(url);
    notification["success"]({
      message: `Enlace copiado en portapapeles`
    })
    return url;
   
  };

  const mapRef = useRef();

  const [checked, setchecked] = useState([]);
  const { coordenadas,iva,datosTotales } = props;
  var puntos = [];
  var puntos2 = [];
  var polilineas = [];
  var peso=[];
  var volumen=[];
  var altura=[]
  var difaltura=[]
  var rutas=[]
  var pendientes=[]
  var gananciasRutaAcc=[]
  var gananciasRuta=[]
  var perdidasRuta=[]

  var orden = "";
 console.log('estas son las coordenadas',coordenadas,datosTotales);
  var color='white';
  var colorP='red';
  var dif=0;
  var difpen=0;
  var auxiliares=[];
  var auxiliare=[];
  var vehicleType=[];
  var j=0;
  var op=0;

  var routes=[];
  var dataBarChart=[];
  var data=[];
  var revenues;
  var revenuesacc=0.0;
  var taxesacc=0.0;
  var costacc=0.0;
  var costPedido=[];
  var costInit=[];
  var pedidosRuta=[];
  var costeFinalRutas=[];
  coordenadas.forEach(element => {
    // console.log(element.tour_info.order_pos,' ',ant)

  })

  function LineGraphEconomic(props) {
    const {data} = props;
    const colors = [
      'red',
      'yellow',
      'green',
    ];
    const config = {
      data,
      height: 400,
      color:colors,
  
      xField: "position",
      yField: "weight",
      seriesField: 'category',
      point: {
        size: 5,
        shape: ({ category }) => {
          return category === 'lost' 
          ? 'square' 
          :(category === 'taxes')
          ? 'circle'
          :(category === 'profit')
          ? 'diamond'
          :'diamond';
        },
      },
    };
  
    return (
      <>
        <Line {...config} />
        {/* <DemoPie />
        <DemoColumn /> */}
      </>
    );
  }



  for (let i = 0; i < coordenadas.length; i++) {
    // console.log('coordenadas[i].position:',coordenadas[i].position,i)
    if(coordenadas[i].tour_info.order_pos===0){
      revenues=0;
    }else if(coordenadas[i].position==='end'){
      var aux=0
      for (let j = 0; j < datosTotales.OUT4_Transp.length; j++) {
        if(datosTotales.OUT4_Transp[j].transp_distance_km==datosTotales.OUT3_Tours[parseInt(coordenadas[i].tour_info.order_tour)].tour_distance_km){
          aux=datosTotales.OUT4_Transp[j].transp_totalcost_eur
          costeFinalRutas.push(aux)
        }
      }
      
        parseInt(coordenadas[i].tour_info.order_vehicle)
        routes.push(<Row justifyContent={'center'}>
        <h1>Route billing {i}: {revenues}€</h1>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
        <h1>Route costs {i}: {aux}€</h1>
        </Row>);

        data.push({
          label: op,
          type: 'revenues',
          value: revenues,
          sex:0,
        })
        data.push({
          label: op,
          type: 'taxes',
          value: parseFloat((revenues*iva*0.01).toFixed(2)),
          // value: parseFloat((revenues/(1-iva*0.01)-revenues).toFixed(2)),
          sex:0,
        })
        data.push({
          label: op,
          type: 'costs',
          value: aux,
          sex:1,
        })
        revenuesacc=revenuesacc+revenues;
        taxesacc=taxesacc+parseFloat((revenues*iva*0.01).toFixed(2));
        costacc=costacc+aux;
        costPedido.push(aux)
        // costPedido.push(aux-datosTotales.IN3_TranspTypes[parseInt(coordenadas[i].tour_info.order_vehicle)].transptype_fixcost)
        costInit.push(datosTotales.IN3_TranspTypes[parseInt(coordenadas[i].tour_info.order_vehicle)].transptype_fixcost)
        op++;
     }else {
      revenues=parseFloat(coordenadas[i].order_revenue) + revenues
    }

    if(coordenadas[i].position=='begin'){
      auxiliare=[]
      auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
      vehicleType.push([coordenadas[i].tour_info.transptype_type])
    }else if(coordenadas[i].position=='end'){
      auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
      auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
      auxiliares=[...auxiliares,auxiliare]
      
      pedidosRuta.push(coordenadas[i].tour_info.order_pos-2)
    }else{
      auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
    }
  }
  // console.log('auxiliares',auxiliares)
  // console.log('data',data)
  // console.log(costPedido,)
  const objectMap = {};
  var obj_id_ant=-8;
  datosTotales.OUT2_Orders.forEach(obj => {
    if(obj_id_ant==obj.order_id){
      objectMap[`${obj.order_id}s`] = obj;
    }else{
      objectMap[obj.order_id] = obj;
    }
    obj_id_ant=obj.order_id
  });

  // console.log('datosTotales.OUT2_Orders: ',datosTotales.OUT2_Orders)
  // console.log('objectMap: ',objectMap)
  const objectMap2 = {};
  const objectMap3 = {};

  datosTotales.OUT3_Tours.forEach(obj => {
    objectMap2[obj.tour_id] = obj;
  });
  var contador=0
  var acumuladorServiceTime=0.0
  var inicial =0.0
  for (let i = 0; i < coordenadas.length; i++) {
    if (filtrarTour(coordenadas[i].tour_info.order_tour, checked)) 
    { 
      puntos.push(coordenadas[i].punto1);
      if(coordenadas[i].position==='begin')inicial=parseFloat(costInit[parseInt(coordenadas[i].tour_info.order_tour)])
      if(coordenadas[i].position==='begin'){acumuladorServiceTime=0.0}
      else if(coordenadas[i].position==='end'){acumuladorServiceTime=acumuladorServiceTime}
      else{ acumuladorServiceTime=acumuladorServiceTime+parseFloat(coordenadas[i].servicetime1)}
      var antGananciaAcc=(i==0||gananciasRutaAcc.length==0)?0:(coordenadas[i-1].position==='begin')?0:gananciasRutaAcc[gananciasRutaAcc.length-1].weight;
      var antTaxesAcc=(i==0||gananciasRutaAcc.length==0)?0:(coordenadas[i-1].position==='begin')?0:gananciasRutaAcc[gananciasRutaAcc.length-2].weight;
      var vehicleInfo=datosTotales.IN3_TranspTypes[parseInt(coordenadas[i].tour_info.order_vehicle)]
      var aux=0
      if(coordenadas[i].order_mode==='shipment'&&objectMap3[coordenadas[i].order_id]!==undefined){
        // console.log('entré',coordenadas[i].order_id)
        aux=`${parseInt(coordenadas[i].order_id)}s`
      }else if(coordenadas[i].order_mode==='shipment'){
        // console.log('ent',coordenadas[i].order_id)
        aux=parseInt(coordenadas[i].order_id)
        objectMap3[coordenadas[i].order_id] = true;
      }else{
        aux=parseInt(coordenadas[i].order_id)
      }
      const order_time =(coordenadas[i].position==='begin')
        ?0
        :(coordenadas[i].position==='end')
          ?(objectMap2[parseInt(coordenadas[i].tour_info.order_tour)].tour_drivingtime_min)/60
          :(objectMap[aux].order_leadtime-acumuladorServiceTime)/60;
          // :(objectMap[parseInt(coordenadas[i].order_id)].order_leadtime-acumuladorServiceTime)/60;
      const order_time_Total =(coordenadas[i].position==='begin')
        ?0
        :(coordenadas[i].position==='end')
          ?(objectMap2[parseInt(coordenadas[i].tour_info.order_tour)].tour_timetotal_min)/60
          :(objectMap[aux].order_leadtime)/60;
          // :(objectMap[parseInt(coordenadas[i].order_id)].order_leadtime)/60;
      // console.log('acumuladorServiceTime: ',acumuladorServiceTime,coordenadas[i].order_id,coordenadas[i].tour_info.order_pos)
      // console.log('km: ',order_time*vehicleInfo.transptype_speed,vehicleInfo.transptype_kmcost,vehicleInfo.transptype_kmcost*order_time*vehicleInfo.transptype_speed)
      // console.log('t: ',order_time_Total,vehicleInfo.transptype_hourcost*order_time_Total)
      // console.log('orderrrrr: ',order_time,'vehicleInfo.transptype_kmcost: ',vehicleInfo.transptype_kmcost,'vehicleInfo.speed: ',vehicleInfo.transptype_speed,'vehicleInfo.trasptype_hourcost: ',vehicleInfo.transptype_hourcost)
      var vehicleCalc=parseFloat((inicial+vehicleInfo.transptype_kmcost*order_time*vehicleInfo.transptype_speed
        +vehicleInfo.transptype_hourcost*order_time_Total).toFixed(2))
      // var vehicleCalc=(coordenadas[i].position==='end')?NaN
      // :parseFloat((inicial+vehicleInfo.transptype_kmcost*order_time*vehicleInfo.transptype_speed
      //   +vehicleInfo.transptype_hourcost*order_time_Total).toFixed(2))
        

      peso.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:coordenadas[i].sumWeight});
      volumen.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:coordenadas[i].sumItems});
      altura.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:parseInt(coordenadas[i].punto1[2])});
      gananciasRuta.push({category: 'lost',position: coordenadas[i].tour_info.order_pos,weight:(coordenadas[i].position==='begin'||coordenadas[i].position==='end')?NaN:(parseFloat(costPedido[parseInt(coordenadas[i].tour_info.order_tour)])/pedidosRuta[parseInt(coordenadas[i].tour_info.order_tour)]).toFixed(2)});
      gananciasRuta.push({category: 'taxes',position: coordenadas[i].tour_info.order_pos,weight:(parseFloat(coordenadas[i].order_revenue)*iva*0.01)});
      gananciasRuta.push({category: 'profit',position: coordenadas[i].tour_info.order_pos,weight:parseFloat(coordenadas[i].order_revenue)});
      gananciasRutaAcc.push({category: 'lost',position: coordenadas[i].tour_info.order_pos,weight:(coordenadas[i].position==='begin')?parseFloat(costInit[parseInt(coordenadas[i].tour_info.order_tour)]):vehicleCalc});
      gananciasRutaAcc.push({category: 'taxes',position: coordenadas[i].tour_info.order_pos,weight:(coordenadas[i].position==='begin')?0.0:(coordenadas[i].position==='end')?gananciasRutaAcc[gananciasRutaAcc.length-3].weight:parseFloat((antTaxesAcc+parseFloat(coordenadas[i].order_revenue)*iva*0.01).toFixed(2))});
      gananciasRutaAcc.push({category: 'profit',position: coordenadas[i].tour_info.order_pos,weight:(coordenadas[i].position==='begin')?0.0:(coordenadas[i].position==='end')?gananciasRutaAcc[gananciasRutaAcc.length-3].weight:(antGananciaAcc+parseFloat(coordenadas[i].order_revenue))});
      dataBarChart.push({
        label: coordenadas[i].tour_info.order_pos,
        type: 'taxes',
        value: parseFloat(coordenadas[i].order_revenue)*iva*0.01,
        sex:0,
      })
      dataBarChart.push({
        label: coordenadas[i].tour_info.order_pos,
        type: 'profit',
        value: parseFloat(coordenadas[i].order_revenue),
        sex:0,
      })
      dataBarChart.push({
        label: coordenadas[i].tour_info.order_pos,
        type: 'lost',
        value: (coordenadas[i].position==='begin'||coordenadas[i].position==='end')
          ?NaN
          :(parseFloat(costPedido[parseInt(coordenadas[i].tour_info.order_tour)])
            /pedidosRuta[parseInt(coordenadas[i].tour_info.order_tour)]).toFixed(2),
        sex:1,
      })
    
    

      if ((i)!==coordenadas.length-1)
        {if(coordenadas[i+1].tour_info.order_pos!==0 ){
          var fromLatLng = L.latLng(coordenadas[i].punto1[0],coordenadas[i].punto1[1]);
          var toLatLng = L.latLng(coordenadas[i+1].punto1[0],coordenadas[i+1].punto1[1]);

          var dis = fromLatLng.distanceTo(toLatLng);
          

          dif=parseInt(coordenadas[i+1].punto1[2])-parseInt(coordenadas[i].punto1[2]);
          (dif===0 || dis ===0)?difpen=0:difpen= 100*dif/dis;
          //console.log(dis , 'dis',dif)
          pendientes.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:difpen})

          ////console.log(coordenadas[i+1].punto[2],'-',coordenadas[i].punto[2],'=',dif)
          difaltura.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:dif})
        }
      }
      
     
      if(coordenadas[i].tour_info.order_pos!==0 && coordenadas[i].hub==null){
        
        (colorP==='black')?colorP='grey':(colorP==='grey')?colorP='brown':colorP='black';
        rutas.push(<Routing  color={colorP} waypoints={puntos}/>)
        // console.log('rutas: ',rutas)
        puntos=[];
      }
      orden = orden + coordenadas[i].nombre + "-> ";
      if(coordenadas[i].order_mode==='delivery'){
        color='green';
      }else if(coordenadas[i].order_mode==='pickup'){
        color='red';
      }else if(coordenadas[i].order_mode==='shipment'){
        color='orange';
      }else{
        color='white';
      }

      
      if(i===coordenadas.length-1){
        puntos2.push(
          <Marker 
          icon={L.divIcon({
           html: `<div class="hub-hidden">
           </div>`,
         })}
           position={coordenadas[i].punto1}>
             <Popup className="popUpMarcador" closeButton={false}>
             <div className="popUpMarcador-top">
               ORDER ID: {coordenadas[i].nombre} <span>({coordenadas[i].order_mode} {coordenadas[i].earlyTime1}-{coordenadas[i].lateTime1})</span>
              </div>
              <div className="popUpMarcador-in">
              <h4>Vehículo: {coordenadas[i].tour_info.transptype} </h4>
              <h4>Capacidad peso: {coordenadas[i].tour_info.transptype_capacity_weight} </h4>
              <h4>Capacidad items: {coordenadas[i].tour_info.transptype_capacity_items} </h4>
              <h4>% de ocupación <span>(peso)</span>: {(100*coordenadas[i].sumWeight/coordenadas[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
              <h4>% de ocupación <span>(items)</span>: {(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
              <h4>Items a recoger/repartir: {coordenadas[i].numberItems} </h4>
              <h4>Peso de los items: {coordenadas[i].peso} </h4>
            </div>
              </Popup>
           </Marker> 
         );
      }else{
        puntos2.push(
          <Marker 
            icon={L.divIcon({
              html: (coordenadas[i].tour_info.order_pos===0 )
              ?`<div class="blue-square" ></div>`
              :`<div class="hub-hidden"></div>`,
            })}
            position={coordenadas[i].punto1}>
                <Popup  
                className="popUpHub"
                closeButton={false}
                >
                <div className="popUpHub-top">
                    {coordenadas[i].nombre} 
                  </div>
                <div className="popUpHub-in">
                  <h4>Vehículo: {coordenadas[i].tour_info.transptype} </h4>
                  <h4>Capacidad peso: {coordenadas[i].tour_info.transptype_capacity_weight} </h4>
                  <h4>Capacidad items: {coordenadas[i].tour_info.transptype_capacity_items} </h4>
                  <h4>% de ocupación <span>(peso)</span>: {(100*coordenadas[i].sumWeight/coordenadas[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
                  <h4>% de ocupación <span>(items)</span>: {(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
                  <h4>Items en vehículo: {coordenadas[i].sumItems} </h4>
                  <h4>Peso de los items: {coordenadas[i].sumWeight} </h4>
                </div>
                
                </Popup> 
   
           </Marker> 
         );
        puntos2.push(
          <Marker 
          icon={L.divIcon({
           
           html: (coordenadas[i].tour_info.order_pos===0  || coordenadas[i+1].tour_info.order_pos===0 )?`<div class="hub-hidden">
           </div>`
           :`<div class="marker-capillar">
              <div class="${color}-circle" >
              </div>
              <div class="number" >
                  ${coordenadas[i].tour_info.order_pos}
              </div>
              
              
            </div>`,
         })}
           position={coordenadas[i].punto1}>
             <Popup className="popUpMarcador" closeButton={false}>
             <div className="popUpMarcador-top">
                ORDER ID: {coordenadas[i].nombre} <span>({coordenadas[i].order_mode} {coordenadas[i].earlyTime1}-{coordenadas[i].lateTime1})</span>
              </div>
              <div className="popUpMarcador-in">
              <h4>Vehículo: {coordenadas[i].tour_info.transptype} </h4>
              <h4>Capacidad peso: {coordenadas[i].tour_info.transptype_capacity_weight} </h4>
              <h4>Capacidad items: {coordenadas[i].tour_info.transptype_capacity_items} </h4>
              <h4>% de ocupación <span>(peso)</span>: {(100*coordenadas[i].sumWeight/coordenadas[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
              <h4>% de ocupación <span>(items)</span>: {(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
              <h4>Items a recoger/repartir: {coordenadas[i].numberItems} </h4>
              <h4>Peso de los items: {coordenadas[i].peso} </h4>
            </div>
              </Popup>
           </Marker> 
         );
         
      }
      
    }
  }

  // console.log(gananciasRutaAcc)
  function myFunction() {
    var popup = document.getElementById("myPopup");
    popup.classList.toggle("show");
  }

  const onChange = (checkedValues) => {
    setchecked(checkedValues);
  };

  function filtrarTour(value, checkboxs) {
    var tour_elegido = false;
    for (let i = 0; i < checkboxs.length; i++) {
      if (value === checkboxs[i]) {
        tour_elegido = true;
        break;
      }
    }
    return tour_elegido;
  }
  var num_tours_v = [];
  var colores;
  var colores_bajo;
  var rutas_descargar = [];
  var aux= parseInt(coordenadas[coordenadas.length-1].tour_info.order_tour)+1; 
  for (let i = 0; i < aux; i++) {

    var ganancias=data[3*i].value
    var impuestos=data[3*i+1].value
    var costes=data[3*i+2].value
    if(costes>impuestos+ganancias){
      colores='rgb(255,0,0)'
      colores_bajo='rgb(255,192,192)'
    }else if(costes<ganancias){
      colores='rgb(40,114,51)'
      colores_bajo='rgb(147,197,114)'
    }else{
      colores='rgb(255,200,0)'
      colores_bajo='rgb(253,253,177)'
    }
    // console.log(colores,costes,ganancias,impuestos)
    num_tours_v.push(<Checkbox value={i.toString()}>{i}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Checkbox>);
    rutas_descargar.push(<Button className="boton"
    disabled={/* disable */false}
    style={{borderColor:colores, 
    backgroundColor: colores_bajo ,
    color:colores,
    fontFamily:'report',
    fontSize:'17px',
    marginRight:'10px'}}
    type="primary"
    onClick =  {() =>
      copiarTexto(auxiliares[i],vehicleType[i][0])
      }>
    {i}&nbsp;{vehicleType[i][0]}
  </Button>);

  }

  var config1 = {
    data: dataBarChart,
    isGroup: true,
    yField: 'value',
    xField: 'label',
    isStack: true,
    groupField: 'sex',
    seriesField: 'type',
    color: ['yellow','green', 'red'],
    label: {
      position: "top",
      layout: [
        { type: "interval-adjust-position" },
        { type: "interval-hide-overlap" },
        { type: "adjust-color" },
      ],
    },
  };

  return (
    <>

    <link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.3/dist/leaflet.css"
     integrity="sha256-kLaT2GOSpHechhsozzB+flnD+zUyjE2LlfWPgU04xyI="
     crossOrigin=""/>
      <script src="https://unpkg.com/leaflet@1.9.3/dist/leaflet.js"
     integrity="sha256-WBkoXOwTeyKclOHuWtc+i2uENFpDZ9YPdf5Hf+D7ewM="
     crossOrigin=""></script>

      <div className="leyenda">
        <div className="rutas" style={{display:'flex',flexFlow:'column' }}>
        <Checkbox.Group style={{marginBottom:'10px', width: "100%" }} onChange={onChange}>
          {num_tours_v}
        </Checkbox.Group>
          <div className="rutas" style={{display:'flex',flexFlow:'row',marginBottom:'10px' }}>
            {rutas_descargar}
          </div>
        </div>

          <div style={{display:'flex',flexFlow:'row',alignItems:'center' }}>

            <div className="orange">
            </div>
            <div className="shipment">
            shipment
            </div>
            <div className="rojo">
            </div>
            <div className="pick-up">
            pick-up
            </div>
            <div className="verde">
            </div>
            <div className="delivery">
            delivery
            </div>
            <div className="azul">
            </div>
            <div className="hubs">
            hubs
            </div>
          </div>
      </div>
      <div className="mapaRow">
        <MapContainer
          ref={mapRef}
          className="leaflet-container"
          center={coordenadas[0].punto1}
          zoom={12}
          /* dragging={true}
          doubleClickZoom={true}
          scrollWheelZoom={true}
          attributionControl={true}
          zoomControl={true} */
          /* whenCreated={setMap} */
        >
          
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {rutas}
          {puntos2}
          {/* {hubs2} */}
          {/* {polilineas} */}
          {/* <Polyline positions={puntos} color="red" /> */}
        </MapContainer>
        {/* <div style={{ border: "10px solid black" }} ref={pluginRef} /> */}
        
      </div>
      <div id="map"></div>
      {/* {(checked.length>0)
        ?<Row  justify="center" gutter={16}>
        <Col  span={24}>
        <div>
            <p></p>
          </div>
          <p>Route evolution (€)</p>
          <LineGraphEconomic

            data={gananciasRuta}
          />
          <div>
            <p></p>
          </div>
        </Col>
      </Row>:<p></p>} */}
      
      {(checked.length>0)
        ?<Row  justify="center" gutter={16}>
        <Col  span={24}>
        <div>
            <p></p>
          </div>
          <p>Orders evolution (€)</p>
          <Column {...config1} />
          <div>
            <p></p>
          </div>
        </Col>
      </Row>:<p></p>}
      {(checked.length>0)
        ?<Row  justify="center" gutter={16}>
        <Col  span={24}>
        <div>
            <p></p>
          </div>
          <p>Route evolution (€)</p>
          <LineGraphEconomic
            data={gananciasRutaAcc}
          />
          <div>
            <p></p>
          </div>
        </Col>
      </Row>:<p></p>}
      
    </>
  );
}
